import Vue from "vue";

// base library
import {
  Button,
  Layout,
  Icon,
  Drawer,
  Radio,
  Menu,
  Form,
  Input,
  Select,
  ConfigProvider,
  Dropdown,
  DatePicker,
  Tabs,
  Checkbox,
  Alert,
  notification,
  Row,
  Col,
  Spin,
  Card,
  Table,
  Modal,
  Avatar
} from "ant-design-vue";

// ext library
import "./directives/action";

Vue.use(Button);
Vue.use(Layout);
Vue.use(Icon);
Vue.use(Drawer);
Vue.use(Radio);
Vue.use(Menu);
Vue.use(Form);
Vue.use(Input);
Vue.use(Select);
Vue.use(ConfigProvider);
Vue.use(Dropdown);
Vue.use(DatePicker);
Vue.use(Tabs);
Vue.use(Checkbox);
Vue.use(Alert);
Vue.use(Row);
Vue.use(Col);
Vue.use(Spin);
Vue.use(Card);
Vue.use(Table);
Vue.use(Modal);
Vue.use(Avatar);

Vue.prototype.$notification = notification;
